import { useField, useFormikContext } from 'formik'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import DatasetSelect from './DatasetSelect'
import { SelectOption } from './types'

export interface DatasetSelectFieldProps {
  fieldName: string
  productId: number
  onSelectedDatasets: React.Dispatch<React.SetStateAction<string[]>>
  refreshHelper?: boolean
  action?: string
  excludeTrainingId?: number
}

const DatasetSelectField = ({
  fieldName,
  productId,
  onSelectedDatasets,
  refreshHelper,
  action,
  excludeTrainingId,
}: DatasetSelectFieldProps) => {
  const { t } = useTranslation()
  const { isSubmitting } = useFormikContext()
  const [field, meta, helpers] = useField<readonly SelectOption[]>(fieldName)

  const { name, value } = field
  const { error, touched, initialValue } = meta
  const { setValue, setTouched } = helpers

  // When action is 'delete', clear the field value.
  // Re-fetch is handled automatically via onMenuOpen inside DatasetSelect.
  useEffect(() => {
    if (action === 'delete') {
      setValue([])
      onSelectedDatasets([])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshHelper])

  return (
    <DatasetSelect
      name={name}
      productId={productId}
      value={value ?? []}
      defaultValue={initialValue}
      onChange={(v: readonly SelectOption[]) => {
        setValue(v)
        onSelectedDatasets(v.map((opt) => String(opt.value)))
      }}
      onBlur={() => setTouched(true)}
      isDisabled={isSubmitting}
      error={!!(error && touched)}
      errorMessage={error}
      noOptionsMessage={() => t('No dataset found')}
      placeholder={t('Select...')}
      excludeTrainingId={excludeTrainingId}
    />
  )
}

export default DatasetSelectField
